module.exports = __webpack_public_path__ + "static/media/car.e2f03804.svg";